<template>
  <div id="app">
    <span>😕 There's nothing to see here.</span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#app {
  padding: 1rem;

  span {
    opacity: 0.7;
  }
}
</style>
